"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentAdConceptLLMSchema = exports.AgentAdConceptLLMScenes = void 0;
const zod_1 = __importDefault(require("zod"));
const agent_ad_concept_shared_1 = require("./agent-ad-concept-shared");
const ActorInputSchema = agent_ad_concept_shared_1.ActorInputBase;
const VoiceInputSchema = agent_ad_concept_shared_1.VoiceInputBase;
const ProductShotInputSchema = agent_ad_concept_shared_1.ProductShotInputBase;
const ImageInputSchema = agent_ad_concept_shared_1.ImageInputBase;
const VideoInputSchema = agent_ad_concept_shared_1.VideoInputBase;
const InputSchema = zod_1.default.object({
    actors: zod_1.default.array(ActorInputSchema),
    voices: zod_1.default.array(VoiceInputSchema),
    productShots: zod_1.default.array(ProductShotInputSchema),
    images: zod_1.default.array(ImageInputSchema),
    videos: zod_1.default.array(VideoInputSchema),
});
// Scenes (LLM variant uses shared scenes without uuid)
exports.AgentAdConceptLLMScenes = agent_ad_concept_shared_1.AgentAdConceptScenesShared;
exports.AgentAdConceptLLMSchema = zod_1.default.object({
    language: zod_1.default.string().describe('The language of the concept as locale code e.g. en-US, de-DE, etc.'),
    title: zod_1.default.string().describe('A concise title for the concept').nullable(),
    shortDescription: zod_1.default
        .string()
        .describe('A concise few wordssummary of the overall concept that highlights the core idea')
        .nullable(),
    conceptReasoning: zod_1.default
        .string()
        .describe('Concise few words reasoning behind this concept; what it is based on and why it will win.')
        .nullable(),
    inputs: InputSchema,
    scenes: zod_1.default
        .array(exports.AgentAdConceptLLMScenes)
        .describe("The array of all scenes that make the video.  Each scene is one visual composition that is visible for a certain amount of time / bound to the voiceover beneath it. One scene can only have one setting! 'Montages' cannot exist. If there are multiple settings, make multiple scenes for each setting. Do not have duplicate scenes with the same assets (e.g. two times the same screen recording after another) - in those cases just make the one scene longer"),
    backgroundMusics: zod_1.default.array(agent_ad_concept_shared_1.BackgroundMusicSchemaShared),
    captions: agent_ad_concept_shared_1.CaptionsSchemaShared,
});
